// i18n config — única fuente de verdad de idiomas/namespaces en el front.
// Idiomas en ISO 639-1 minúscula, alineados con USER.language del backend.
export const DEFAULT_LANGUAGE = 'en'

// ⭐ ÚNICA lista de idiomas de la app. Añadir un idioma = 1 entrada aquí + carpeta
// src/locales/<code>/ con todos los namespaces (los registra tools/gen-i18n-resources.js).
// La consumen: el switcher de perfil, el selector de idioma de los setting reports,
// y `SUPPORTED_LANGUAGES` (derivado).
//   value  = identidad (ISO 639-1, = USER.language / report.language)
//   i18nKey = label display traducible (namespace común)
//   flag    = bandera en /public (solo la usa el switcher de perfil; el report va sin bandera)
//   locale  = (opcional) variante regional BCP 47 cuando la del código ISO no es la nuestra: `Intl` resuelve
//             'pt' como pt-BR (p. ej. plural: 0 → singular); con 'pt-PT' se usan las reglas europeas.
export const APP_LANGUAGES = [
    { value: 'en', i18nKey: 'common:languages.en', flag: '/assets/flags/gb.svg' },
    { value: 'es', i18nKey: 'common:languages.es', flag: '/assets/flags/es.svg' },
    { value: 'pt', i18nKey: 'common:languages.pt', flag: '/assets/flags/pt.svg', locale: 'pt-PT' },
    { value: 'de', i18nKey: 'common:languages.de', flag: '/assets/flags/de.svg' },
]

export const SUPPORTED_LANGUAGES = APP_LANGUAGES.map(l => l.value)

// Namespaces = union of the JSON files found in src/locales/<lang>/ (generated list).
export { NAMESPACES } from 'i18n/resources.generated'
export const DEFAULT_NAMESPACE = 'common'

// Tolerant normalization of stored language codes ('pt-PT', 'pt_PT', 'PT', legacy 'es_ES') → 'pt' / 'es'.
// Returns null when the code is not a supported language.
export function normalizeLanguage(code) {
    if (typeof code !== 'string' || !code) return null
    const lang = code.split(/[-_]/)[0].toLowerCase()
    return SUPPORTED_LANGUAGES.includes(lang) ? lang : null
}

// BCP 47 locale for `Intl` APIs (regional variant when declared): 'pt' → 'pt-PT', 'es' → 'es'.
export function intlLocale(code) {
    const lang = normalizeLanguage(code) || DEFAULT_LANGUAGE
    return APP_LANGUAGES.find(l => l.value === lang)?.locale || lang
}

// Resuelve el idioma inicial: localStorage.language (hidratado en login por saveSession) → fallback EN.
export function resolveInitialLanguage() {
    return normalizeLanguage(localStorage.getItem('language')) || DEFAULT_LANGUAGE
}
